import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { isStandalone } from '../hooks/usePWAInstall';
import PWAInstallButton from './PWAInstallButton';
import { trackGA4Event } from '../lib/gtag';

/**
 * InstallDeepLink — Vollbild-Install-Screen bei ?install=1 (QR-Scan-Ziel).
 * Scannen → Seite öffnet → 1 Tap auf den großen Button → App installiert.
 */
export default function InstallDeepLink() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('install') === '1' && !isStandalone()) {
      setOpen(true);
      trackGA4Event('pwa_install_deeplink_opened', { source: 'qr' });
      // Param aus der URL entfernen, damit Reload/Navigation sauber bleibt
      params.delete('install');
      const qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''));
    }
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] bg-stone-950 flex flex-col items-center justify-center px-6 animate-in fade-in duration-300"
      data-testid="pwa-install-deeplink"
    >
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="absolute top-4 right-4 w-10 h-10 rounded-full text-stone-400 hover:text-white hover:bg-white/10 flex items-center justify-center transition-colors"
        aria-label="Schließen"
        data-testid="pwa-deeplink-close"
      >
        <X className="w-5 h-5" strokeWidth={2.4} />
      </button>

      <div
        className="absolute -top-24 right-0 w-80 h-80 rounded-full opacity-25 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(62,255,126,0.5) 0%, transparent 70%)' }}
        aria-hidden="true"
      />

      <img src="/apple-touch-icon.png" alt="FUEL.X App" className="w-20 h-20 rounded-3xl border border-white/15 mb-6" />
      <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-emerald-300 mb-3">FUEL.X App</p>
      <h1 className="font-display text-white text-3xl sm:text-4xl tracking-[-0.02em] leading-tight text-center">
        Fast geschafft —<br /><span className="text-emerald-400">1 Tap bis zur App.</span>
      </h1>
      <p className="text-sm text-stone-400 leading-relaxed mt-4 max-w-xs text-center">
        Kein App Store nötig. Tippe auf den Button und bestätige — fertig.
      </p>
      <PWAInstallButton
        variant="primary"
        label="App jetzt installieren"
        testId="pwa-deeplink-install-btn"
        className="mt-8 !px-8 !py-4 !text-base"
      />
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="mt-5 text-[12px] text-stone-500 hover:text-stone-300 transition-colors underline underline-offset-4"
        data-testid="pwa-deeplink-skip"
      >
        Später — erst mal zur Website
      </button>
    </div>
  );
}
